export const COLORS = {
    primary: '#5ECE7B',
    background: 'white',
    text: '#1D1F22'
  };

  export const MoneyTypeSymbol={
    "USD":"$",
    "GBP":"£",
    "AUD":"A$",
    "JPY":"¥",
    "RUB":"₽"
  }